export const LOCAL_STORAGE_KEY = {
  USER_CREDENTIALS: 'ngx-webstorage|session.user',
  CATEGORIES_MENU: 'douleutaras|categories_menu'
};

// Shared TTL for both the server-side in-process cache
// (src/server/lib/categoriesMenuCache.ts) and the client-side localStorage
// fallback (src/redux/data/v2/categoriesMenu/categoriesMenuSlice.ts) used on
// pages that never go through SSR.
export const CATEGORIES_MENU_CACHE_TTL_SECONDS = 24 * 60 * 60; // 24h

export const LANGUAGES = {
  EN: {
    CODE: 'en'
  },
  EN_IE: {
    CODE: 'en-ie'
  },
  EL: {
    CODE: 'el'
  },
  EL_CY: {
    CODE: 'el-cy'
  }
};

export enum LANGUAGE_CODES {
  EN = 'en',
  EN_IE = 'en-ie',
  EL = 'el',
  EL_CY = 'el-cy'
}

export enum PAYMENT_BANK {
  // Extend this ENUM if needed...
  STRIPE = 'stripe',
  STRIPE_UNATTENDED = 'stripe_unattended',
  SEPA = 'sepa',
  BANK = 'bank'
}

export const isDevelopment = process.env.NODE_ENV !== 'production';

// Would be "true" for production and production.stage and testing env
export const isProduction = process.env.NODE_ENV === 'production';

// Would be "true" ONLY for production
export const isRealProduction = process.env.REAL_ENV === 'production';
